var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : {};
var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Link = require('react-router').Link;
var moment = require('moment');
var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var modalActions = require('../../modules/modals/actions/modal');

var ActionMenu = createReactClass({
    mixins: [PureRenderMixin],

    $actionMenuWrapper: null,

    componentDidMount: function(){
        this.$actionMenuWrapper = $('.action-menu-wrapper');

        if(Foundation.MediaQuery.atLeast('large')){
            this.$actionMenuWrapper.addClass('is-open');
        }

        $(document).on('click.actionMenu', function(event){
            if($(event.target).parents('#collectZipCode-reveal-wrapper, .action-menu-wrapper').length === 0){
                this.$actionMenuWrapper.removeClass('is-open');
            }
        }.bind(this));
    },

    componentWillUnmount: function(){
        $(document).off('click.actionMenu');
    },

    handleMenuTriggerClick: function(e){
        this.$actionMenuWrapper.toggleClass('is-open');
    },

    handleTourTrigglerClick: function(e){
        e.preventDefault();
        this.$actionMenuWrapper.removeClass('is-open');
        this.props.showModal('MODAL_TYPE_TUTORIAL_TOUR');
    },

    handleLinkClick: function(){
        this.$actionMenuWrapper.removeClass('is-open');
    },

    handleFindOutClinicalTiralsClick: function(e){
        e.preventDefault();
        this.$actionMenuWrapper.removeClass('is-open');
        if(!this.props.profile.contactForTrials){
            this.props.showModal('MODAL_TYPE_INTERESTED_IN_CLINICAL_TRIALS');
        }
    },

    render: function(){

        return (
            <div className="action-menu-wrapper">
                <div className="action-menu-inner-wrapper">
                    <div className="action-menu">
                        <h3>What would you like <br />to do today?</h3>
                        <ul className="no-bullet">
                            <li><Link onClick={this.handleTourTrigglerClick}><span className="icon icon-tour"></span>Take Tour</Link></li>
                            <li><Link onClick={this.handleLinkClick} to="/surveys/promis"><span className="icon icon-symptom-tracker"></span>Update Your Symptoms</Link></li>
                            <li><Link onClick={this.handleLinkClick} to="/surveys/myqol"><span className="icon icon-quality"></span>Take Quality of Life Survey</Link></li>
                            <li><Link onClick={this.handleFindOutClinicalTiralsClick}><span className="icon icon-trials"></span>Find Out About Clinical Trials{this.props.profile.contactForTrials && <span className="ion-ios-checkmark"></span>}</Link></li>
                            <li><Link onClick={this.handleLinkClick} to="/surveys/gihistory"><span className="icon icon-doctor-visit"></span>Prep for Your Doctor Visit</Link></li>
                        </ul>
                    </div>
                    <button id="actionMenuTrigger" type="button" onClick={this.handleMenuTriggerClick}><span className="month">{moment().format('MMM')}</span><span className="day">{moment().date()}</span></button>
                </div>
            </div>
        )
    }
});

var mapStateToProps = function(state){
    return {
        profile: state.profile.data
    };
}

var mapDispatchToProps = function(dispatch) {
  return bindActionCreators(Object.assign({}, modalActions), dispatch);
}

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(ActionMenu);



// WEBPACK FOOTER //
// ./src/common/routes/components/actionMenu.jsx